import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import './custom-bootstrap.scss';
import './includes/skipToMainContent';
import ReactDOM from 'react-dom';
import App from './App';

const rootElement = document.getElementById('root');

ReactDOM.render(<App />, rootElement);
